export const REQUEST_FORM_SUBMIT_PAYMENT = 'REQUEST_FORM_SUBMIT_PAYMENT';
export const SUCCESS_FORM_SUBMIT_PAYMENT = 'SUCCESS_FORM_SUBMIT_PAYMENT';
export const FAILURE_FORM_SUBMIT_PAYMENT = 'FAILURE_FORM_SUBMIT_PAYMENT';

export const RESET_FORM_SUBMIT_PAYMENT = 'RESET_FORM_SUBMIT_PAYMENT';

export const SET_TIMEOUT_ID = 'SET_TIMEOUT_ID';
export const CLEAR_TIMEOUT_ID = 'CLEAR_TIMEOUT_ID';

export const PAYMENT_REQUEST_TYPE_IBAN = 1;
export const PAYMENT_REQUEST_TYPE_ASSOCIATION = 2;
export const PAYMENT_REQUEST_TYPE_NURSURY = 3;



// WEBPACK FOOTER //
// ./src/services/account/paymentrequest/request/constants.js